import folderStore from "owa-folders";
import updateFolderCounts, { type UPDATE_FOLDER_COUNTSActionMessage, } from "owa-mail-folder-actions/lib/updateFolderCounts";
import { onUpdateFolderNotification, type OnUpdateFolderNotificationActionMessage, } from "owa-mail-actions/lib/folderNotificationActions";
import { getFolderIdForSelectedNode } from "owa-mail-folder-forest-store";
import { mutator } from "satcheljs";
import { UnifiedInboxSupportedFolders } from "owa-folders-constants";
import { getUniqueUnifiedInboxFolderId } from "owa-folders-data-utils/lib/getUniqueUnifiedInboxFolderId";
import { isGlobalFeatureEnabled } from "owa-feature-flags";

// TODO - Eventually these mutators should be removed with scenarios that depend on the folder counts
// start reading it from the cache
const defaultExport: (actionMessage: UPDATE_FOLDER_COUNTSActionMessage) => void = mutator(updateFolderCounts, actionMessage => {
    updateFolderCountsInternal(actionMessage.unreadCount, actionMessage.totalCount, actionMessage.folderId, actionMessage.isDeltaChange);
});
export default defaultExport;

export const updateFolderCountsUponHierarchyPayload: (actionMessage: OnUpdateFolderNotificationActionMessage) => void = mutator(onUpdateFolderNotification, actionMessage => {
    updateFolderCountsInternal(actionMessage.unreadCount, actionMessage.totalCount, actionMessage.folderId, false /* isDeltaChange */);
    
    // If the display name has changed, updated it and update the folder heirarchy
    const folder = folderStore().folderTable.get(actionMessage.folderId);
    if (folder && folder.displayName !== actionMessage.displayName) {
        folder.displayName = actionMessage.displayName;
    }
});

function updateFolderCountsInternal(unreadCount: number, totalCount: number, folderId: string, isDeltaChange: boolean) {
    const folderTable = folderStore().folderTable;
    const folder = folderTable.get(folderId);
    
    if (folder) {
        // Initialize diffs as delta changes for
        // Unified Inbox updates.
        let unreadCountDiff = unreadCount;
        let totalCountDiff = totalCount;
        
        if (isDeltaChange) {
            folder.UnreadCount += unreadCount;
            folder.totalMessageCount += totalCount;
        }
        else {
            // For non-delta changes, calculate the difference
            // between the new counts and the existing counts, because if these are new values
            // We need to know how much to update the counts by.
            unreadCountDiff = unreadCount - folder.UnreadCount;
            totalCountDiff = totalCount - folder.totalMessageCount;
            folder.UnreadCount = unreadCount;
            folder.totalMessageCount = totalCount;
        }
        
        // If user is currently in a favorite persona folder and folder count changes, update cached
        // total count value so we don't show new message count badge.
        if (folder.pausedTotalCount && getFolderIdForSelectedNode() === folderId) {
            folder.pausedTotalCount = folder.totalMessageCount;
        }
        
        // Do not let counts fall below 0 in the store. This state could happen due to the timing of when
        // folder tree is loaded versus listview.
        folder.UnreadCount = Math.max(folder.UnreadCount, 0);
        folder.totalMessageCount = Math.max(folder.totalMessageCount, 0);
        
        // If the folder is a unified inbox folder, update the unified inbox folder counts as well.
        if (isGlobalFeatureEnabled("acct-unifiedInbox") &&
            folder.distinguishedFolderType &&
            UnifiedInboxSupportedFolders.indexOf(folder.distinguishedFolderType) >= 0) {
            const unifiedInboxFolderId = getUniqueUnifiedInboxFolderId(folder.distinguishedFolderType);
            const unifiedInboxFolder = folderTable.get(unifiedInboxFolderId);
            if (unifiedInboxFolder) {
                // Update the unified inbox folder counts with the deltas or calculated differences
                unifiedInboxFolder.UnreadCount += unreadCountDiff;
                unifiedInboxFolder.totalMessageCount += totalCountDiff;
                
                // Do not let counts fall below 0 in the store.
                unifiedInboxFolder.UnreadCount = Math.max(unifiedInboxFolder.UnreadCount, 0);
                unifiedInboxFolder.totalMessageCount = Math.max(unifiedInboxFolder.totalMessageCount, 0);
            }
        }
    }
}
